// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"IconTooltip_tooltip__FREaE","infoIcon":"IconTooltip_infoIcon__8i7_b"};